import { badgeConfig } from './../../conf/config';

import firebaseApp from './../../utils/firebase/firebase';

import * as types from './pointsActionTypes';

const updatePoints = ( currentPoints, totalPoints ) => {
    return {
        type: types.UPDATE_POINTS,
        currentPoints,
        totalPoints
    }
}

const attributeBadge = (badgeToAttribute) => {
    return {
        type: types.ATTRIBUTE_BADGES,
        badgeToAttribute
    }
}

const badgeEarned = (payload) => {
    return {
        type: types.BADGE_EARNED,
        payload
    }
}


export const processUpdatedPoints = ( currentPoints, totalPoints ) => {
    return (dispatch, getState) =>{

        if(getState().points.isInit)
        {
            const previousTotalPoints = getState().points.totalPoints;
            let badgeToAttribute = [];

            for(var i=0; i<badgeConfig.length; i++)
            {
                badgeToAttribute[i] = (badgeConfig[i].pointsRequired <= totalPoints) !== (badgeConfig[i].pointsRequired <= previousTotalPoints);
                //we dispatch the action for the action logger
                if(badgeToAttribute[i])
                {
                    let payload = {
                        action:'unlock',
                        entityId: i,
                        entityValue: '',
                        value:'',
                        point: false
                    }
                    dispatch(badgeEarned(payload));
                }
            }

            if(badgeToAttribute.includes(true))
            {
                dispatch(attributeBadge(badgeToAttribute));
            }
        }
        
        
        dispatch(updatePoints( currentPoints, totalPoints ));
    }
}

export const updateBadgeToAttribute = (badgeToAttribute) => {
    return (dispatch) => {
        var newBadgeToAttribute = [...badgeToAttribute];
        newBadgeToAttribute[badgeToAttribute.indexOf(true)] = false;
        dispatch(attributeBadge(newBadgeToAttribute));
    }
}

export const destroyPointsListeners = (userId) => {
    // unbind firebase listeners for Points
    firebaseApp.database().ref(`users/${ userId }/points`).off();

    return {
        type: types.DESTROY_POINTS
    }
}

export const updateFirebasePoints = ( currentPoints, totalPoints ) => {
    var updates = {};
    updates[`users/${ firebaseApp.auth().currentUser.uid }/points`] = {
        currentPoints,
        totalPoints
    };

    firebaseApp.database().ref()
        .update(updates)
        .catch((err)=>{
        console.error('[ACTION LOGGER] updatePoints error : ', err);
    });
}



// WEBPACK FOOTER //
// ./src/components/Points/pointsActions.js